module.exports = __webpack_public_path__ + "img/Data-Engineer_Blog-scaled-3725142537.82740d5e.jpeg";